import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button, Card, Alert, InputGroup, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // Importar useNavigate
import "./ListaDeCajas.css";
import { FaSearch } from "react-icons/fa";

const ListaDeCajas = () => {
  const [cajasCerradas, setCajasCerradas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState("");
  const comercioId = localStorage.getItem("comercioId");

  const navigate = useNavigate(); // Hook para navegar entre rutas

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const fetchCajasCerradas = async (page, from = startDate, to = endDate) => {
    const paramsBusqueda = {
      _id: comercioId,
      page,
    };

    if (from && to) {
      paramsBusqueda.desde = from;
      paramsBusqueda.hasta = to;
    }
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/public/v2/List/Boxes`,
        {
          headers: {
            "Content-Type": "application/json",
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
          },
          params: paramsBusqueda,
        }
      );
      if (response.status === 200 && response.data.ok) {
        setCajasCerradas(response.data.msg);
        setCurrentPage(response.data.page || page);
        setTotalPages(response.data.totalPages || 1);

        sessionStorage.setItem(
          "boxesFilters",
          JSON.stringify({
            startDate: from,
            endDate: to,
            page: response.data.page || page,
          })
        );
       
      } else {
        setCajasCerradas([]);
        setTotalPages(1);
        setError("No se encontraron cajas cerradas.");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching cajas cerradas:", error);
      setError(error.response.data.msg || "Error al obtener las cajas cerradas. Inténtelo de nuevo.");
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      fetchCajasCerradas(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      fetchCajasCerradas(currentPage - 1);
    }
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "-";
    const date = new Date(timestamp);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleViewHistory = (idBox) => {
    sessionStorage.setItem("returnFromBoxDetail", "true");
    // Navegar al nuevo componente con el idBox como parámetro
    navigate(`/historial/${idBox}`, {
      state: {
        startDate,
        endDate,
        currentPage,
      },
    });
  };

  const [loading, setLoading] = useState(false);

  const handleSearch = () => {
    if (!startDate || !endDate) {
      alert("Por favor, ingresa ambas fechas para realizar la búsqueda.");
      return;
    }
    sessionStorage.setItem(
      "boxesFilters",
      JSON.stringify({
        startDate,
        endDate,
        page: 1,
      })
    );

    fetchCajasCerradas(1, startDate, endDate);
  };
  useEffect(() => {
    const saved = sessionStorage.getItem("boxesFilters");

    if (saved) {
      const filters = JSON.parse(saved);

      setStartDate(filters.startDate || "");
      setEndDate(filters.endDate || "");

      fetchCajasCerradas(filters.page || 1, filters.startDate, filters.endDate);
    } else {
      fetchCajasCerradas(1);
    }

    return () => {
      const returnFromDetail = sessionStorage.getItem("returnFromBoxDetail");

      if (returnFromDetail === "true") {
        sessionStorage.removeItem("returnFromBoxDetail");
      } else {
        clearFilters();
      }
    };
  }, []);
  const clearFilters = () => {
    sessionStorage.removeItem("boxesFilters");
    sessionStorage.removeItem("returnFromBoxDetail");
  
    setStartDate("");
    setEndDate("");
    setCurrentPage(1);
  
    fetchCajasCerradas(1, "", "");
  };
  return (
    <Card className="lista-de-cajas-card">
      <h3 className="lista-de-cajas-header">Cajas Cerradas</h3>
      {error && <Alert variant="danger">{error}</Alert>}

      <div className="d-flex align-items-center mb-3">
        <InputGroup className="me-2" style={{ width: "300px" }}>
          <InputGroup.Text style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Inicio:
          </InputGroup.Text>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ height: "38px" }}
          />
        </InputGroup>

        <InputGroup className="me-2" style={{ width: "300px" }}>
          <InputGroup.Text style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Fin:
          </InputGroup.Text>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{ height: "38px" }}
          />
        </InputGroup>

        <Button
          variant="primary"
          onClick={handleSearch}
          disabled={loading}
          style={{ width: "10%", height: "38px" }}
          className="btn btn-primary custom-button"
        >
          <FaSearch className="me-1" />
          {loading ? "Buscando..." : "Buscar"}
        </Button>

        <Button
          variant="outline-secondary p"
          onClick={clearFilters}
          disabled={loading || (!endDate && !startDate)}
          style={{ height: "38px", marginLeft: "8px" }}
        >
          Limpiar filtros
        </Button>
      </div>

      <Table striped bordered hover className="lista-de-cajas-table">
        <thead>
          <tr>
            <th>ID de Caja</th>
            <th>Fecha Apertura</th>
            <th>Fecha Cierre</th>
            <th>Balance</th>
            <th>balance QR</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {cajasCerradas.map((caja) => (
            <tr key={caja._id}>
              <td>{caja.idBox}</td>
              <td>{formatTimestamp(caja.dateOpen)}</td>
              <td>{formatTimestamp(caja.dateClose)}</td>
              <td>${caja.balance ? caja.balance.toFixed(2) : "0.00"}</td>
              <td>${caja.balanceQR ? caja.balanceQR.toFixed(2) : "0.00"}</td>
              <td>
                <Button
                  variant="link"
                  onClick={() => handleViewHistory(caja.idBox)}
                >
                  Ver historial
                </Button>
              </td>
            </tr>
          ))}
        
        </tbody>
      </Table>

      <div className="lista-de-cajas-buttons">
        <Button
          variant="secondary"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          Anterior
        </Button>
        <Button
          variant="secondary"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Siguiente
        </Button>
      </div>
    </Card>
  );
};

export default ListaDeCajas;
